import React, {useState} from "react";
import Dialog from "js/common/views/dialog";
import {TextButton} from "js/common/views/inputs/buttons";
import * as Colors from "js/common/cube19-colors";
import {CustomThemeContext} from "js/common/themes/CustomThemeProvider";

const DiscardConfirmationDialog = ({changedMetrics, onSubmit, onCancel}) => {
  const [showAll, setShowAll] = useState(false);
  const {theme} = React.useContext(CustomThemeContext);

  const dialogTitle = <span>Are you sure you want to discard your changes?</span>;

  const closeButtonStyle = {
    backgroundColor: Colors.greyLight,
    color: "white",
    borderRadius: 60,
    padding: "8px 10px",
    fontSize: 12
  };

  const displayedMetrics = showAll
      ? changedMetrics
      : changedMetrics.slice(0, 10);

  const hasMoreMetrics = changedMetrics.count() > 10;

  return (
      <Dialog
          fullWidth={false}
          maxWidth={500}
          transitionDuration={{exit: 0, enter: 200}}
          enableScroll={false}
          closeButtonStyle={closeButtonStyle}
          onClose={onCancel}
          title={dialogTitle}
          titleIcon="info"
          autoDetectWindowHeight={true}
          bodyStyle={{overflow: "visible"}}
          actionsContainerStyle={{paddingRight: "2rem"}}
          open={true}
          onBackdropClick={onCancel}
          actions={[
            <TextButton
                key="cancel"
                type="dark"
                label="Cancel"
                style={{marginLeft: "0.5rem", marginRight: "0.5rem", marginBottom: "1rem"}}
                onClick={onCancel}
            />,
            <TextButton
                testId="discard-changes-button"
                key="submit"
                type="primary"
                label="Discard"
                style={{marginLeft: "0.5rem", marginRight: "0.5rem", marginBottom: "1rem"}}
                onClick={() => onSubmit()}
            />
          ]}
      >
        <div style={{minWidth: 500}}>
          <p>The following metrics will be reverted:</p>
          <ol style={{paddingLeft: "1.5rem", margin: "0.5rem 0"}}>
            {displayedMetrics.map((kpi, index) => (
                <li key={index} style={{margin: "0.25rem 0"}}>
                  {kpi.getIn(["kpi", "name"])}
                </li>
            ))}
          </ol>

          {hasMoreMetrics && (
              <div style={{marginTop: "0.5rem"}}>
                <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setShowAll(!showAll);
                    }}
                    style={{
                      color: theme.palette.primary.main,
                      textDecoration: "none",
                      cursor: "pointer"
                    }}
                >
                  {showAll ? "Show Less" : `Show ${changedMetrics.count() - 10} More`}
                </a>
              </div>
          )}
        </div>
      </Dialog>
  );
};

export default DiscardConfirmationDialog;